import { LocalStorageKeys } from '~/apps/smartsend/lib/consts/LocalStorageKeys';
import { useCallback, useMemo, useSyncExternalStore } from 'react';

// 4.0.0 is the version where we introduced the new SmartSend onboarding flow
export const SmartSendVersions = {
  Default: '3.0.0',
  SmarterSending: '4.0.0',
  Angular: 'V2',
  React: '2.0.0',
  Legacy: 'V1'
};

type SmartSendVersion = keyof typeof SmartSendVersions | string;

const useSmartSendVersion = () => {
  const subscribe = (callback: () => void) => {
    window.addEventListener('storage', callback);
    return () => window.removeEventListener('storage', callback);
  };

  const isSmartSendSetup = useCallback(() => {
    return !!localStorage.getItem(LocalStorageKeys.SmartSendSetup);
  }, []);

  const preferredVersion = useCallback(() => {
    return localStorage.getItem(LocalStorageKeys.SmartSendPreferredVersion) ?? SmartSendVersions.Default;
  }, []);

  const localStorageValue: boolean = useSyncExternalStore(subscribe, isSmartSendSetup);
  const smartSendPreferredVersion: SmartSendVersion = useSyncExternalStore(subscribe, preferredVersion);

  const version = useMemo(() => {
    if (localStorageValue) {
      return SmartSendVersions.SmarterSending;
    }
    return smartSendPreferredVersion as SmartSendVersion;
  }, [localStorageValue, smartSendPreferredVersion]);

  return version;
};

export default useSmartSendVersion;
